<template>
    <span class="o-services__tile services__tile">
        <span class="services__tile-icon-container">
            <img
                class="services__tile-icon"
                :src="iconSrc"
                :alt="`${$t('services_tile-icon')}`"
            >
        </span>
        <span class="services__title">
            {{ name }}
        </span>
        <span class="services__info">
            {{ objectsCount }} st
        </span>
    </span>
</template>

<script>
export default {
    name: 'OServicesTile',
    props: {
        iconSrc: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        objectsCount: {
            type: Number,
            default: 0
        }
    }
}
</script>

<style lang="scss">
@import "o-services-tile";   
</style>